class ProductSupportList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const productGrid = document.querySelector('[data-section-type="ProductSupportGrid"]');
    if (!productGrid) {
      return;
    }

    this.runProcess(productGrid);
  }

  runProcess(container = document) {
    const parentItems = container.querySelectorAll('[data-product-support-category]');
    this.checkLocationForChildren(window.location.hash, container);
    // supportGridStandardizeHeights($container);

    // Additional logic for handling hash changes and popstate events
    window.addEventListener('popstate', (e) => {
      const state = e.state;
      if (state === null) {
        this.displayParentItems(container);
        return;
      }

      const { category } = state;
      this.hideParentItems(container);
      this.displayChildrenItems(category, container);
    });

    // Logic for handling events, like clicking on parent items
    parentItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        this.handleParentItemClick(e, container);
      });
    });
  }

  verifyChildrenExist(category, container) {
    const childrenItems = container.querySelectorAll(`[data-product-support-child-for='${category}']`);

    if (childrenItems.length === 0) {
      return false;
    }

    return true;
  }

  checkLocationForChildren(hash, container) {
    const category = hash.substring(1);
    if (this.verifyChildrenExist(category, container)) {
      this.hideParentItems(container);
      this.displayChildrenItems(category, container);
    } else {
      // const location = window.location.pathname;
      // this.handleStateChanges(null, null, location);
    }
  }

  hideParentItems(container) {
    const parentItems = container.querySelectorAll('[data-product-support-category]');
    const standaloneItems = container.querySelectorAll('[data-standalone]');

    // Hide all parent items
    parentItems.forEach((item) => {
      item.style.display = 'none';
    });

    // Hide standalone items if they exist
    if (standaloneItems.length) {
      standaloneItems.forEach((item) => {
        item.style.display = 'none';
      });
    }
  }

  displayParentItems = (container) => {
    const parentItems = container.querySelectorAll('[data-product-support-category]');
    const childrenItems = container.querySelectorAll('[data-product-support-child-for]');
    const standaloneItems = container.querySelectorAll('[data-standalone]');

    // Set display to 'flex' for parent items
    parentItems.forEach((item) => {
      item.style.display = 'flex';
    });

    // Hide all children items
    childrenItems.forEach((item) => {
      item.style.display = 'none';
    });

    // Show standalone items if they exist
    if (standaloneItems.length) {
      standaloneItems.forEach((item) => {
        item.style.display = 'flex';
      });
    }

    // supportGridStandardizeHeights($container);
    this.scrollToTop();
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  displayChildrenItems(category, container) {
    const childrenItems = container.querySelectorAll(`[data-product-support-child-for='${category}']`);

    // If no child items exist, exit the function
    if (childrenItems.length === 0) {
      return;
    }

    // Hide parent items
    this.hideParentItems(container);

    // Set display to 'flex' for each child item
    childrenItems.forEach((item) => {
      item.style.display = 'flex';
    });

    // Standardize grid heights
    // this.supportGridStandardizeHeights(container);

    // Scroll to top of the page
    this.scrollToTop();
  }

  handleParentItemClick(e, container) {
    e.preventDefault();

    // Access the data attribute using vanilla JavaScript
    const currentCategory = e.currentTarget.getAttribute('data-product-support-category');

    // Check if the category is missing or empty
    if (!currentCategory) {
      throw new Error('Category is missing for tile');
    }

    const state = { category: currentCategory };

    // Hide parent items and update the state
    this.hideParentItems(container);
    this.handleStateChanges(state, 'children', `#${currentCategory}`);

    // Display the child items for the current category
    this.displayChildrenItems(currentCategory, container);
  }

  handleStateChanges(state, title, url) {
    history.pushState(state, title, url);
  }
}

customElements.define('product-support-list', ProductSupportList);
